import { createContext } from 'react';
import type { TourDefinition } from './types';

/**
 * The currently displayed tour, if any. Lives in its own module so that the
 * overlay components and the provider don't form a circular import.
 */
export interface ActiveTour {
  definition: TourDefinition;
  stepIndex: number;
}

export interface TourContextValue {
  active: ActiveTour | null;
  hydrated: boolean;
  startTour: (tourId: string, opts?: { force?: boolean }) => Promise<void>;
  /** Advance to the next visible step (honors ``skipIf``). */
  next: () => Promise<void>;
  /** Go back one visible step (honors ``skipIf``). */
  prev: () => Promise<void>;
  skip: () => Promise<void>;
  complete: () => Promise<void>;
  hasSeen: (tourId: string) => boolean;
  resetTour: (tourId: string) => Promise<void>;
}

export const TourContext = createContext<TourContextValue | undefined>(undefined);
